/* eslint-disable no-magic-numbers */
import { NgClass } from '@angular/common';
import { Component, input, OnInit, signal } from '@angular/core';
import { PromoType } from '@data/domain/promo.entity';
import { CurrencyPipe } from '@shared/pipes/currency.pipe';
import { PackageCard } from './package-card';
import { OriginalPriceComponent } from './components/original-price/original-price.component';
import { SalesProgressBarComponent } from './components/sales-progress-bar/sales-progress-bar.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-package-card',
  standalone: true,
  imports: [CurrencyPipe, NgClass, OriginalPriceComponent, SalesProgressBarComponent, TranslatePipe],
  templateUrl: './package-card.component.html',
  styleUrl: './package-card.component.scss'
})
export class PackageCardComponent implements OnInit {
  data = input<PackageCard>();
  isAffiliatePackage = input<boolean>();

  isAffiliateProgram = signal<boolean>(localStorage.getItem('promoType') === 'affiliate' as PromoType);

  hasValueOriginalPrice = signal<boolean | number | undefined>(false);

  ngOnInit(): void {
    this.hasValueOriginalPrice.set(this.data()?.originalprice && this.data()?.originalprice !== 0 && this.data()?.discountPercentage && this.data()?.discountPercentage !== 0);
  }
}
